import type { TaActivityItem } from '../../../../shared/types/ta-metrics';


/** KPIs de la pestaña Actividad sobre las consultas cargadas (no sobre todo el histórico). */
export function activityStats(items: TaActivityItem[]) {
  const n = items.length;
  const users = new Set(items.map((i) => i.user.toLowerCase())).size;
  const lat = items.map((i) => i.latencyMs).filter((v) => v > 0).sort((a, b) => a - b);
  const medianMs = lat.length ? lat[Math.floor(lat.length / 2)] : 0;
  // Mismo filtro que las filas: el KPI cuenta lo que se ve como advertencia
  const flagged = items.filter((i) => visibleIssues(i.validation.issues).length > 0).length;
  const regenerated = items.filter((i) => i.validation.regenerated).length;
  const analiticas = items.filter((i) => i.clasificacion?.tipo === 'analitica').length;
  return { n, users, medianMs, flagged, regenerated, analiticas };
}

/** Advertencias que valen para la persona (las de estilo quedan en el audit). */
export const visibleIssues = (issues: string[]) => issues.filter((i) => !/^respuesta larga/.test(i));
